import * as Api from '@ViewModels';
import { LocationDescriptor } from 'history';
import { parse as getQueryStringParams } from '@AppModels/QueryStringUtils';
import * as React from 'react';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { IUserSessionComponentProps } from '../../../models/AppState';
import { logoutAndClearCaches } from '../../../models/UiUtils';
import { ICredential } from '../../../viewmodels/AppViewModels';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { getInAppPath } from '../../utils/inAppPath';
import { logoutFromServer } from '../Logout/logoutFromServer';

interface IProps<TUserSession extends Api.UserSessionContext = Api.UserSessionContext>
	extends RouteComponentProps<any>,
		IUserSessionComponentProps {
	redirection?: LocationDescriptor<any>;
	userSession: TUserSession;
}

interface IState {
	loading?: boolean;
	redirectPath?: string;
}

class _CustomerSessionStart extends React.Component<IProps, IState> {
	public state: IState = {
		loading: true,
	};

	public async componentDidMount() {
		const { location, userSession } = this.props;
		const signOut = await logoutFromServer(userSession);
		if (!signOut.success) {
			// The credential stored below still outranks the surviving cookie for this tab's requests.
			console.error('Failed to end the previous server session:', signOut);
		}
		logoutAndClearCaches();

		const { redirect, ...credential } = getQueryStringParams(location.search || '');
		userSession.webServiceHelper.getCredentialStore().setCredential(credential as ICredential);
		userSession.load()?.then(() => {
			this.setState({
				loading: false,
				redirectPath: getInAppPath(redirect),
			});
		});
	}

	public render() {
		const { loading, redirectPath } = this.state;
		const { redirection } = this.props;
		if (loading) {
			return <LoadingSpinner type='login' />;
		}

		return <Redirect to={redirectPath ?? redirection} />;
	}
}

export const CustomerSessionStart = withRouter(_CustomerSessionStart);
